import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginButton from './LoginButton';
import { ROUTES } from '../routes';
import YearNavLink from './YearNavLink';
import { MdLogout as MdLogoutRaw } from 'react-icons/md';
import SearchInput from './SearchInput';

function formatDateDDMMYYYY(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export default function ArchiveHeader() {
    const {
        currentUser,
        logout,
    } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isAdmin = currentUser?.isAdmin();
    const accessUntil = currentUser?.getAccessUntil();

    // Extract the year from the pathname
    const match = location.pathname.match(/^\/(20\d{2})\/?.*$/);
    const year = match ? match[1] : null;
    const MdLogout = MdLogoutRaw as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    return (
        <header className="page-header">
            <div className="page-header-top-section">
                <img className="logo clickable" onClick={() => navigate(ROUTES.HOME)} src="/gds-logo.svg" alt="Logo" />

                <nav className="links button-text">
                    <YearNavLink to={2024} />
                </nav>

                <SearchInput />

                {currentUser ? (
                    <div className="button-text account-name-logout">
                        {isAdmin && <button className="button-text" onClick={() => navigate(ROUTES.UPLOAD)}>Upload lecture</button>}
                        {isAdmin && 'Admin: '}
                        {currentUser.email}{' '}
                        {accessUntil && (
                            <span className="access-until">
                                (Access until: {formatDateDDMMYYYY(accessUntil)})
                            </span>
                        )}{' '}
                        <button className="icon-button button-text" onClick={logout}>
                            <MdLogout />
                        </button>
                    </div>
                ) : (
                    <LoginButton onClick={() => navigate(ROUTES.LOGIN)} />
                )}
            </div>
            <div className="page-header-title">
                <h1 className="header-title-text">
                    Video Archive GDS Prague {year}
                </h1>
            </div>
        </header>
    );
}
